const InterlakenSettings = {
  leftSidebar: {
    show: true,
    mode: "full", // full, close, compact, mobile,
    theme: "slateDark1", // View all valid theme colors inside EgretTheme/themeColors.js
    bgOpacity: 0.96, // 0 ~ 1
    bgImgURL: "/assets/images/sidebar/sidebar-bg-dark.jpg",
  },
  topbar: {
    show: true,
    fixed: true,
    theme: "white", // View all valid theme colors inside EgretTheme/themeColors.js
  },
  footer: {
    show: false,
  },
};

export default InterlakenSettings;
